<div class="summary-line_table">

  <span class="instrument-name">
    {{getInstrumentName(instrument)}}
  </span>

  <div
    class="with-tip"
    *ngIf="currentTab.type === 'instrument'"
  >
    <div class="company">
      {{instrument.company || instrument.name}}
    </div>
    <span class="tip">
      {{instrument.company || instrument.name}}
    </span>
  </div>

  <iv-live-dropdown-new
    *ngIf="currentTab.type === 'future'"
    class="filter-expiration"
    [class.filter-expiration-hide-charts]="hideCharts"
    [formControl]="expiration"
    [listValues]="expirations"
    withoutDivider
  ></iv-live-dropdown-new>

  <div class="btn-container">
    <div
      class="with-tip"
      style="height: 24px;"
      [style.margin-right]="hasOptions ? '5px' : '0'"
    >
      <a
        statistic
        [statisticElementName]="'Watch tutorial'"
        href="https://www.youtube.com/watch?v=HY9K6SRdQFA"
        target="_blank"
      >
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACIklEQVRIidWVz2sTQRTHP7MbqQpeKkWjUaFHA/5AJclJT55ELdEcPHqSgggWFEHMBIr2oB56Kf0LxMVgvfQfUGoMlGoCOYqkNSlSDXixLc0+D0maTTObXb31Cwszs9/3/c5785iB3Q4VyHAcm0glhagEIkfbqytYFCmxgNbu/xnMTw+x3hhH5CFwyIe1iqgpXJkhozfDG+R1DJgDzg3anQclLK4xpr8FG+QnT8BWATgcUryDOk2SZHTV32B+eog/v4rAKYPAF1BvW0MZA04bOEttk+1yWT2/1xvjRnHFK4Y5TzqbI53NsRa9ALw2GJwlwh1zBo5jY1e+03+gW1iMIMQQ3rUSsK6yd0+NjY0fQGQHv06ZWKe7uhlEKimDOEADlwzwAhgFRrHc21x51AC+GvhR4iQ7E2+JkgYywAgwi3C5Pd+kac3hvNwHRI0RymxgJveiiahb3HzyHvu3Bg74GBwxGYTBU25k8+RzE8CDMAFdA1G1EPz9vNH3QZ4PZAnbWp4OUAWQIIOJELcXKBY6w24GZfcjsBoQ+qH9DUKNMsV+A61dRE0NCKxS5iLNk5eAZV+W8Mx7w/YesiszCJ99Qg9yxopjVeLAsA9nkZ/RWe9Cf0UdfRybAuHa1osadiTJ9cc92fW3aUZXaZIElv5BfBFI7BQ3G3hNFPeA+gDhOsJd1qIp0nrFRAhuOq0t4iSxVQJXjrW2pZZBFSi5n4KezN2Pvw7WpK5LkS4RAAAAAElFTkSuQmCC"
        />
      </a>
      <span
        class="tip"
        style="text-align: center; padding: 5px; width: 140px;"
      >
        Watch tutorial
      </span>
    </div>
    <iv-live-image-button
      (buttonClicked)="onEditColumnsClick()"
      *ngIf="hasOptions && !hideCharts"
      [tip]="'Settings'"
      id="editSummaryLineColumnsButton"
      style="min-width: 25px"
    >
      <span class="material-icons">&#xE8B8;</span>
    </iv-live-image-button>
    <iv-live-dropdown
      (selectedDataChange)="selectGroup($event)"
      [cssClass]="'add-to-favorites'"
      [data]="groups"
      [tip]="currentTab.type === 'instrument' ? 'Add to Stock Monitor' : 'Add to Future Monitor'"
      [type]="'button'"
      [valueAttribute]="'name'"
    >
    </iv-live-dropdown>
  </div>

  <span class="date" *ngIf="currentTab.type === 'instrument'">Quote time: {{isEodDate ? closeDateString : (updateDateString || closeDateString)}}</span>

  <div
    class="with-tip"
    *ngIf="currentTab.type === 'future'"
  >
    <div class="company">
      {{instrument.company || instrument.name}}
    </div>
    <span class="tip">
      {{instrument.company || instrument.name}}
    </span>
  </div>

  <span
    *ngIf="instrumentInfo?.industry"
    [class.new-line]="!hasOptions"
    class="with-tip industry"
  >Industry: {{instrumentInfo?.industry}}
    <span class="tip">
      Industry of the underlying company
    </span>
  </span>

</div>

<div>
  <iv-live-summary-line-table
    (hvLabelChange)="setHv($event)"
    (ivxLabelChange)="setIvx($event)"
    [hv]="hv"
    [ivx]="ivx"
    *ngIf="instrumentInfo && !hideCharts"
    [class.small]="!hasOptions"
    [columns]="columns"
    [data]="instrumentInfo"
    [instrument]="instrument"
    [visibleColumns]="visibleColumns"
    (HVInit)="HVInit.emit($event)"
    (IVXInit)="IVXInit.emit($event)"
  ></iv-live-summary-line-table>
</div>

<dx-popup
  [(visible)]="editColumnsPopupVisible"
  [class]="editColumnsClass"
  [closeOnOutsideClick]="true"
  [dragEnabled]="false"
  [height]="editColumnsPopupHeight"
  [position]="editColumnsPopupPosition"
  [shading]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="'Column Settings'"
  [width]="415"
>
  <div *dxTemplate="let data of 'content'">
    <iv-live-columns-chooser
      (columnSwitch)="onColumnSwitch($event)"
      (saveDefault)="saveDefault($event)"
      [columns]="settingColumns"
      [visibleColumns]="visibleColumns"
    ></iv-live-columns-chooser>
  </div>
</dx-popup>
